import type { OpenPanel } from '@openpanel/sdk';
import { config } from './config';
import { isPatientHost } from './portalHost';

let clientPromise: Promise<OpenPanel> | undefined;

export const initOpenPanel = (): void => {
  if (clientPromise || isPatientHost() || !config.OPENPANEL_CLIENT_ID || !config.OPENPANEL_API_URL) {
    return;
  }

  clientPromise = import('@openpanel/sdk').then(({ OpenPanel }) => {
    const client = new OpenPanel({
      clientId: config.OPENPANEL_CLIENT_ID,
      apiUrl: config.OPENPANEL_API_URL,
      sdk: 'web',
    });
    return client;
  });
};

const withClient = (action: (client: OpenPanel) => void | Promise<unknown>): void => {
  initOpenPanel();
  if (!clientPromise) return;
  void clientPromise.then(action).catch(() => {
    // Analytics must never affect clinician workflows.
  });
};

export const trackOpenPanelEvent = (
  name: string,
  properties: Record<string, string | number | boolean>,
): void => {
  withClient(client => client.track(name, {
    ...properties,
    clinician_portal_version: 'v2',
  }));
};

export const trackOpenPanelView = (path: string): void => {
  // Supply both fields directly so patient IDs and document titles cannot leak.
  withClient(client => client.track('screen_view', {
    __path: path,
    __title: path,
    clinician_portal_version: 'v2',
  }));
};

export const identifyOpenPanelClinician = (
  id: string,
  properties: Record<string, string>,
): void => {
  withClient(client => client.identify({ profileId: id, properties }));
};

export const clearOpenPanelClinician = (): void => {
  withClient(client => client.clear());
};
